export default __webpack_public_path__ + "static/media/kalotka.9ff7d4e1.jpg";